import React from 'react';

const AboutCard = ({ icon, title }) => {
    return (
        <div className="about-one__card">
            <div className="about-one__icon">
                {icon}
            </div>
            <h3>{title}</h3>
        </div>
    );
};

export default AboutCard;
